// Generated by CoffeeScript 1.12.7
/* global window:false, document: false, Cookie: false */

window.create_subscription_result_banner = function(
  bannerType,
  bannerMessage,
  displayStyle
) {
  const desktopHeader = document.querySelector('.header-v2');
  if (
    !document.getElementById('email_subscription_subanner') &&
    desktopHeader
  ) {
    const template = `
  <div id="email_subscription_subanner" style="${displayStyle}">
    <div id="subscription_success_banner" class="notification ${bannerType} five subscribe_success">
      ${bannerMessage}
      <span class="icon-x"></span>
    </div>
</div>
  `;
    const fragment = document.createRange().createContextualFragment(template);
    desktopHeader.parentNode.insertBefore(fragment, desktopHeader.nextSibling);
    // prettier-ignore
    const bannerClose = document.querySelector("#subscription_success_banner .icon-x");
    bannerClose.addEventListener('click', () => {
      const bannerDiv = document.querySelector('#email_subscription_subanner');
      bannerDiv.parentNode.removeChild(bannerDiv);
    });
  }
};

window.set_subscription_result_banner_text = function(bannerMessage) {
  let innerDiv;
  if (document.getElementById('subscription_success_banner') !== null) {
    innerDiv = document.getElementById('subscription_success_banner');
    return (innerDiv.innerHTML = bannerMessage);
  }
};

window.retrySubscriptionAfterFailure = function() {
  let TEN_YEARS_IN_SECONDS, visited;
  if (typeof Cookie !== 'undefined' && Cookie !== null) {
    TEN_YEARS_IN_SECONDS = 60 * 60 * 24 * 365 * 10;
    visited = parseInt(Cookie.get('subscription_visited'));
    if (isNaN(visited)) {
      visited = 1;
    } else {
      --visited;
    }
    Cookie.set('subscription_visited', visited, {
      maxAge: TEN_YEARS_IN_SECONDS * 1000,
      domain: document.domain,
    });
  }
  window.location.reload();
  return false;
};
